// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"764":"1bede94112af8bf56b2d","898":"39963590dd610bd5c1b5"}[chunkId] + ".js";
};